<div class="mt-32">
  <table class="tbl tbl--full tbl--hovered">
    <colgroup>
      <col width="4%" />
      <col width="15%" />
      <col />
      <col width="4%" />
      <col width="12%" />
    </colgroup>
    <thead>
      <tr>
        <th>ID</th>
        <th>Название</th>
        <th>Описание</th>
        <th>Версия</th>
        <th>Отображение в системе</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="functions && functions.length">
        <tr *ngFor="let func of functions" [ngClass]="{ 'color-gray-dark': !func.is_visible }">
          <td>{{ func.sf_id }}</td>
          <td>
            <app-role-access [action]="'disable'" [permission]="'service_function.edit'" [placement]="'bottom-left'">
              <button data-role-element id="{{ 'appOpenEditServiceFunctionDialog' + func.sf_id }}" (click)="onOpenServiceFunctionDialog.emit(func)">
                <a
                  class="link"
                  [ngClass]="{
                    'link--dotted-blue-dark': func.is_visible,
                    'link--dotted-gray-dark': !func.is_visible
                  }"
                >
                  {{ func.service_function_name }}
                </a>
              </button>
            </app-role-access>
          </td>
          <td>{{ func.description }}</td>
          <td>{{ func.version_number }}</td>
          <td>
            <app-role-access [action]="'disable'" [permission]="'service_function.change.is_visible'" [placement]="'bottom-right'">
              <app-checkbox-slider>
                <input
                  data-role-element
                  type="checkbox"
                  [checked]="func.is_visible"
                  id="{{ 'appChangeStateServiceFunction' + func.sf_id }}"
                  (change)="onChangeStateFunction($event, func)"
                />
              </app-checkbox-slider>
            </app-role-access>
          </td>
        </tr>
      </ng-container>
      <tr *ngIf="functionQuery" class="tr--reset-highlight">
        <td colspan="5">
          <div class="ta-center color-gray-dark pt-32 mt-8">По критериям “Функция: {{ functionQuery }}” ничего не найдено.</div>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="mt-32 ta-center" *ngIf="functions && functions.length">
    <button type="button" id="appShowAllServiceFunction" class="button" (click)="onChangeVisibilityAllFunctions.emit()" [disabled]="isActiveShowAllFunctionsButton">
      Показать все функции
    </button>
  </div>
</div>
